import Axios from 'axios'
import type {
  TAuthEventType,
  TReportAuthEventRequest
} from '@homepal/api-contract'

const API_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

/**
 * Reports a sign-in event to the API, with the address the user typed when
 * there is one. Never throws: a failed report does not reach the user.
 */
export async function reportAuthEvent(
  type: TAuthEventType,
  email?: string | null
): Promise<void> {
  const body: TReportAuthEventRequest = { data: { type, email } }

  try {
    await Axios.post(`${API_URL}v1/public/auth-events`, body)
  } catch (e) {
    // Reporting is best effort.
  }
}
